import { Settings } from 'lucide-react';
import { useAppStore, type ViewMode } from '@/lib/store';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const VIEW_META: Record<ViewMode, { lane: string; label: string }> = {
    dashboard: { lane: 'Study', label: 'Dashboard' },
    manuscript: { lane: 'Write', label: 'Manuscript' },
    dictionary: { lane: 'Write', label: 'Dictionary' },
    stats: { lane: 'Write', label: 'Stats' },
    challenges: { lane: 'Write', label: 'Challenges' },
    constellation: { lane: 'Plan', label: 'Constellation' },
    corkboard: { lane: 'Plan', label: 'Stickies' },
    timeline: { lane: 'Plan', label: 'Timeline' },
    compost: { lane: 'Write', label: 'Compost' },
    studio: { lane: 'Publish', label: 'Studio' },
    admin: { lane: 'Admin', label: 'CRM' },
};

const LANE_TO_MODE: Record<string, ViewMode> = {
    Study: 'dashboard',
    Write: 'manuscript',
    Plan: 'constellation',
    Publish: 'studio',
    Admin: 'admin',
};

export function ViewBreadcrumbs() {
    const { viewMode, setViewMode, setShowSettings, themeProfile } = useAppStore();
    const meta = VIEW_META[viewMode];

    return (
        <div
            className="h-12 px-4 md:px-6 border-b flex items-center justify-between"
            style={{ borderColor: themeProfile.border, backgroundColor: `${themeProfile.paperSurface}CC` }}
        >
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <button
                            onClick={() => setViewMode(LANE_TO_MODE[meta.lane])}
                            className="text-sm font-medium opacity-70 hover:opacity-100"
                        >
                            {meta.lane}
                        </button>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>{meta.label}</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>

            <button
                onClick={() => setShowSettings(true)}
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold border"
                style={{ borderColor: themeProfile.border }}
            >
                <Settings className="w-3.5 h-3.5" />
                Settings
            </button>
        </div>
    );
}
